import Vue from "vue";
import Vuex from "vuex";

import state from "./state";
import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

import Common from "./modules/common/store";
import Tour from "./modules/tour/store";
import Tickets from "./modules/tickets/store";
import Basket from "./modules/basket/store";
import Quotes from "./modules/quotes/store";
import Hotels from "./modules/hotels/store";


Vue.use(Vuex);

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  modules: {
    common: Common,
    tour: Tour,
    tickets: Tickets,
    basket: Basket,
    quotes: Quotes,
    hotels: Hotels
  },
});
